import { render, staticRenderFns } from "./PlayCard.vue?vue&type=template&id=c4cac4f0&scoped=true"
import script from "./PlayCard.vue?vue&type=script&lang=js"
export * from "./PlayCard.vue?vue&type=script&lang=js"
import style0 from "./PlayCard.vue?vue&type=style&index=0&id=c4cac4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cac4f0",
  null
  
)

export default component.exports